import { render, staticRenderFns } from "./CustomerIntegrationEdit.vue?vue&type=template&id=cf095576"
import script from "./CustomerIntegrationEdit.vue?vue&type=script&lang=js"
export * from "./CustomerIntegrationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports